<div class="circle" [style.background-color]="color"></div>
